<template>
  <el-dialog title="角色授权" :visible.sync="centerDialogVisible" @close="cancel">
    <div>
      <el-row style="margin-bottom:32px;">
        <el-col :span="8" class="title">
          <div class="grid-content bg-purple-dark">
            子系统
          </div>
        </el-col>
        <el-col :span="12">
          <span class="sysName">{{ name }}</span>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:32px">
        <el-col :span="8" class="title">
          <div class="grid-content bg-purple-dark">
            角色授权
          </div>
        </el-col>
        <el-col :span="12">
          <div style="border:1px solid rgba(0,0,0,0.15);padding:8px">
            <el-tree ref="tree" :data="data" show-checkbox default-expand-all node-key="id" highlight-current
              :props="defaultProps" :default-expanded-keys="checkData" :default-checked-keys="checkData">
              <span slot-scope="{ node, data }">
                <span>
                  <i class="file" />{{ node.label }}
                </span>
              </span>
            </el-tree>
          </div>

        </el-col>
      </el-row>
      <!-- <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark" style="float:right;text-align:right;border-top:1px solid #E8E8E8;padding-top:8px;margin-top:60px;width:100%">
          <el-button style="margin-right:8px" @click="cancel">取消</el-button>
          <el-button type="primary" @click="sure">确认</el-button>
        </div>
      </el-col>
    </el-row> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button style="margin-right:8px" @click="cancel">取消</el-button>
      <el-button type="primary" @click="sure">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import { rolePermissionsList, rolePermission, systemDetail } from '@/api/system'
  var commitData = [];
  export default {
    props: ['appId', 'roleId'],
    data() {
      return {
        props: {
          label: 'name',
          children: 'zones'
        },
        count: 1,
        data: [],
        defaultProps: {
          children: 'child',
          label: 'name'
        },
        permisList: [],
        idList: '',
        idArr: [],
        list: [],
        checkData: [],
        name: null,
        centerDialogVisible: true,
      }
    },
    mounted() {
      this.getPermission()
      this.getSystemName()
    },
    methods: {
      recursion(arr, res) {
        const _this = this
        if (arr.length > 0) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].child.length > 0) {
              arr[i].checked = false
            }
            if (arr[i].checked) {
              res.push(arr[i].id)
            }
            _this.recursion(arr[i].child, res)

          }
        }
      },
      getPermission() {
        rolePermissionsList({
          appId: this.appId,
          roleId: this.roleId
        }).then(res => {
          if (res && res.code == 0) {
            this.data = res.data
            this.recursion(this.data, this.checkData)
          }
        })
      },
      // 角色授权
      roleAuthorization() {
        rolePermission({
          appId: this.appId,
          roleId: this.roleId,
          permissionIds: this.idList
        }
        ).then(res => {
          if (res && res.code == 0) {
            this.$message.success('授权成功')
            this.$emit('returnResult')
          }
        })
      },
      sure() {
        const _this = this
        const arr = this.$refs.tree.getCheckedKeys()
        _this.list = this.$refs.tree.getHalfCheckedKeys()
        const keyArr = arr.concat(_this.list)
        _this.idArr = this.unique(keyArr)
        _this.idList = _this.idArr.toString()
        console.log(_this.idList)
        this.roleAuthorization()
      },
      cancel() {
        this.$emit('returnResult')
      },
      // 去重方法
      unique(arr) {
        return Array.from(new Set(arr))
      },
      // 系统名称
      getSystemName() {
        systemDetail({
          id: this.appId
        }).then(res => {
          if (res && res.code == 0) {
            this.name = res.data.name
          }
        })
      }

    }
  }
</script>
<style lang="scss" scoped>
  .title {
    text-align: right;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    margin-right: 16px;
    line-height: 30px;
  }

  .sysName {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    line-height: 30px;
  }

  .el-tree {
    font-size: 12px;
  }

  .file {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: contain;
    background-image: url("../../../../assets/icon.png");
    margin-right: 8px;
  }
  /deep/.el-tree-node__content>.el-tree-node__expand-icon{
    padding:0px;
  }
</style>